import { getDocument } from '@sitecore-search/common';
import { getDomainHost } from '../config.js';
const doc = getDocument({ cookie: '' });
if (!doc.cookie) {
    doc.cookie = '';
}
export default class CookieHandler {
    getCookieValue(content, cookieName) {
        const tmpValue = content.slice(cookieName.length + 1, content.length);
        if (tmpValue) {
            return decodeURIComponent(tmpValue);
        }
        return '';
    }
    getCookieFromBrowser(cookieName) {
        const rawCookies = doc.cookie.split('; ');
        for (let i = 0; i < rawCookies.length; i++) {
            if (rawCookies[i].slice(0, cookieName.length) === cookieName) {
                return this.getCookieValue(rawCookies[i], cookieName);
            }
        }
        return '';
    }
    setCookieInBrowser(name, value, milliseconds) {
        const expiryDate = new Date();
        let newValue = encodeURIComponent(value);
        expiryDate.setMilliseconds(expiryDate.getMilliseconds() + milliseconds);
        newValue += `;domain=${getDomainHost()};path=/;`;
        newValue += !milliseconds ? '' : `;expires=${expiryDate.toUTCString()}`;
        newValue += ';secure;SameSite=None;';
        doc.cookie = `${name}=${newValue}`;
    }
    removeCookieFromBrowser(name) {
        doc.cookie = `${name}=;domain=${getDomainHost()};path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT;secure;SameSite=None`;
    }
    removeCachedCookie(name) {
        this.removeCookieFromBrowser(name);
    }
    set(key, value, expire) {
        if (value) {
            const newValue = typeof value === 'object' ? JSON.stringify(value) : value;
            this.setCookieInBrowser(key, newValue, expire);
        }
        else {
            this.removeCachedCookie(key);
        }
    }
    get(key) {
        return this.getCookieFromBrowser(key);
    }
    remove(key) {
        this.removeCachedCookie(key);
    }
}
